export default __webpack_public_path__ + "static/media/softMes.5eaf5bd2.png";